import { Component, Input } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ChatService } from '../../../models/chat/chatService';
import { StorageService } from '../../../core/storage/storageService';
import { ChatWindowComponent } from '../chat-window.component';

@Component({
  selector: 'app-launch-chat-button',
  templateUrl: './launch-chat-button.component.html',
  styleUrls: ['./launch-chat-button.component.scss'],
  standalone: false,
})
export class LaunchChatButtonComponent {
  constructor(
    private chat: ChatService,
    private dialog: MatDialog,
    private storage: StorageService,
  ) {}

  @Input() showIcon: boolean = true;
  private chatRef: MatDialogRef<ChatWindowComponent> | undefined;

  ngOnInit() {
    const conversationId = this.storage.getConversationId();
    if (conversationId != null) this.openChat();
  }

  public disabled(): boolean {
    return this.dialog.openDialogs.length != 0;
  }

  public openChat() {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.data = {
      conversationId: '',
      role: 'guest',
    };
    dialogConfig.hasBackdrop = false; // this makes it non-modal
    dialogConfig.panelClass = 'custom-dialog-container';

    this.chatRef = this.dialog.open(ChatWindowComponent, dialogConfig);
  }

  public closeChat() {
    this.chatRef?.close();
  }
}
